import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, Descriptions, Badge, Button, message, Modal } from 'antd';
import { Context } from '../../../defaults';
import { getUser } from '../../../actions';
import moment from 'moment';
import jwt from 'jwt-decode';
import { LockOutlined, SecurityScanOutlined } from '@ant-design/icons';
import { saveChangePassword } from '../../../actions';

const AdminsProfile = () => {
  const { dictionary, language, links, setLoading } = useContext(Context);
  const [form] = Form.useForm();
  const [user, setUser] = useState({});
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [added, setAdded] = useState('')

  useEffect(() => {
    const t = localStorage.getItem('token');
    const persistedToken = jwt(t);
    if (persistedToken && persistedToken['nameid']) {
      setLoading(true);
      getUser(persistedToken['nameid']).then((res) => {
        setUser(res.data);
        setLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    if (added) {
      setAdded(false);
      const t = localStorage.getItem('token');
      const persistedToken = jwt(t);
      if (persistedToken && persistedToken['nameid']) {
        setLoading(true);
        getUser(persistedToken['nameid']).then((res) => {
          setUser(res.data);
          setLoading(false);
        });
      }
    }
  }, [added]);

  return (
    <React.Fragment>
      <Descriptions title={dictionary?.Profile[language]} bordered>
        <Descriptions.Item span={2} label={dictionary?.UserName[language]}>
          {user.login}
        </Descriptions.Item>
        <Descriptions.Item label="Email" span={2}>
          {user.email}
        </Descriptions.Item>
        <Descriptions.Item label={dictionary?.RegDate[language]} span={3}>
          {moment(user.regDate).format('DD.MM.YYYY')}
        </Descriptions.Item>
        <Descriptions.Item label={dictionary?.LastLoginDate[language]} span={3}>
          {moment(user.lastLoginDate).format('DD.MM.YYYY')}
        </Descriptions.Item>
        <Descriptions.Item label={dictionary?.LastChangePassDate[language]} span={2}>
          {moment(user.lastChangePassDate).format('DD.MM.YYYY')}{' '}
        </Descriptions.Item>
        <Descriptions.Item label={dictionary?.Password[language]}>
          <Button
            type="dashed"
            icon={<SecurityScanOutlined />}
            onClick={() => {
              setOpenChangePasswordModal(true);
            }}>
            {dictionary?.ChangePassword[language]}
          </Button>
        </Descriptions.Item>
        <Descriptions.Item label={dictionary?.ActiveFlag[language]} span={3}>
          <Badge
            status="processing"
            text={user.active === 1 ? dictionary?.Active[language] : dictionary?.Passive[language]}
          />
        </Descriptions.Item>

        <Descriptions.Item label={dictionary?.Tasks[language]} span={3}>
          {links && links.map((el) => <p key={el.id}>{el[language]}</p>)}
        </Descriptions.Item>
      </Descriptions>

      <Modal
        onOk={() => {
          const { password, rePassword } = form.getFieldsValue();
          if (password === rePassword) {
            setLoading(true);
            saveChangePassword({ password })
              .then((res) => {
                setLoading(false);
                setOpenChangePasswordModal(false);
                form.resetFields();
                setAdded(true);
                message.success(dictionary?.SuccessfullyChanged[language], { duration: 2 });
              })
              .catch(() => {
                setLoading(false);
                form.resetFields();
                message.error(dictionary?.SomethingWentWrong[language], { duration: 4 });
              });
          } else {
            form.validateFields();
            message.error(dictionary?.PasswordsAreNotSame[language]);
          }
        }}
        okButtonProps={{ disabled: buttonDisabled }}
        onCancel={() => {
          setOpenChangePasswordModal(false);
        }}
        title={dictionary?.ChangePassword[language]}
        visible={openChangePasswordModal}>
        <Form
          form={form}
          style={{ marginTop: 24 }}
          onFieldsChange={() => {
            const { password, rePassword } = form.getFieldsValue();
            setButtonDisabled(!password || !rePassword);
          }}>
          <Form.Item
            name="password"
            rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder={dictionary?.Password[language]}
            />
          </Form.Item>
          <Form.Item
            name="rePassword"
            rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder={dictionary?.RePassword[language]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </React.Fragment>
  );
};
export default AdminsProfile;
